"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State_1 = require("./Constants/State");
var BufferFullnessExit_1 = require("./Constants/BufferFullnessExit");
var updateVariantRebuffer_1 = require("./updateVariantRebuffer");
function createStateRebuffer() {
    return {
        label: State_1.default.REBUFFER,
        entry: function (params) {
            var abrState = params.abrState, callbacks = params.callbacks, metrics = params.metrics;
            callbacks.setTimeoutFirstByte(1000);
            callbacks.setTimeoutLoad(4000);
            var setCurrentVariantIndex = callbacks.setCurrentVariantIndex;
            updateVariantRebuffer_1.default({
                abrState: abrState,
                metrics: metrics,
                setCurrentVariantIndex: setCurrentVariantIndex
            });
        },
        update: function (params) {
            var abrState = params.abrState, metrics = params.metrics, callbacks = params.callbacks;
            var bufferDepth = metrics.bufferedDuration.min;
            if (bufferDepth >= BufferFullnessExit_1.default.REBUFFER_TO_STEADY) {
                callbacks.setState(State_1.default.STEADY);
            }
            else if ((bufferDepth > 0) && (bufferDepth <= BufferFullnessExit_1.default.REBUFFER_TO_PANICMODE)) {
                callbacks.setState(State_1.default.PANICMODE);
            }
            else {
                var setCurrentVariantIndex = callbacks.setCurrentVariantIndex;
                updateVariantRebuffer_1.default({
                    abrState: abrState,
                    metrics: metrics,
                    setCurrentVariantIndex: setCurrentVariantIndex
                });
            }
        }
    };
}
exports.default = createStateRebuffer;
//# sourceMappingURL=createStateRebuffer.js.map